import * as dd from 'dingtalk-jsapi';
import request from './request';
import { setToken, setRefreshToken, getToken, removeToken, removeRefreshToken } from './token';


/**
 * @description 获取Table的高度
 * @param {Object} that
 */
window.onGetTableHeight = function (that) {
  let tempNumber = window.innerHeight - that.$refs.divSearch.offsetHeight - 240
  return tempNumber > 300 ? tempNumber : window.innerHeight - 120
}


/**
 * @description 获取用户信息
 * @param {Object} that
 */
window.onGetNowUser = function(that) {
  let tpUser = that.$GetKey(that.$cacheTeacher);
  if (regNull(tpUser)) {
    that.$RemoveKey();
    warning(that, "登录失效，请重新登陆！");
    var fullPath = decodeURI(that.$router.history.current.fullPath).toLowerCase();
    setTimeout(function() {
      if (dd.env.platform !== "notInDingTalk") {
        that.$router.push({
          path: '/DingDing',
          query: {
            url: that.$router.history.current.fullPath
          },
        });
      } else {
        if (fullPath.indexOf("login?url=") < 0) {
          that.$router.push({
            path: '/login',
            query: {
              url: that.$router.history.current.fullPath
            },
          });
        } else {
          that.$router.push({
            path: that.$router.history.current.fullPath,
          });
        }
      }
      return false;
    }, 1500);
    return false;
  } else {
    return JSON.parse(tpUser);
  }
}

/**
 * @description 获取当前角色
 * @param {Object} that
 */
window.onGetNowRole = function (that) {
  let tpRole = that.$GetKey('nowRole');
  if (regNull(tpRole)) {
    that.$RemoveKey();
    warning(that, "登录失效，请重新登陆！");
    var fullPath = decodeURI(that.$router.history.current.fullPath).toLowerCase();
    setTimeout(function () {
      if (dd.env.platform !== "notInDingTalk") {
        that.$router.push({
          path: '/DingDing',
          query: {
            url: that.$router.history.current.fullPath
          },
        });
      } else {
        if (fullPath.indexOf("login?url=") < 0) {
          that.$router.push({
            path: '/login',
            query: {
              url: that.$router.history.current.fullPath
            },
          });
        } else {
          that.$router.push({
            path: that.$router.history.current.fullPath,
          });
        }
      }
      return false;
    }, 1500);
    return false;
  } else {
    return JSON.parse(tpRole);
  }
}


/**
 * @description 页面定时刷新时间 （单位：分钟）
 */
window.onGetRegularRefresh = function () {
  let tpTime = webRegularRefresh();
  if (regNull(tpTime) || Number(tpTime) <= 0) {
    return 1;
  } else {
    return tpTime;
  }
}

window.routerPath = function (that, path, need, val, ...values) { // 路由地址 要传的建 要传的值  报保存的值
  let arr = [];
  if (typeof need == "string") { // 如果是单个值就对应传入
    arr[need] = val;
  } else if (typeof need == "object" && need != null) { //  否则传个对应对象给他    其余的值自己传入
    for (const key in need) {
      if (Array.isArray(need[key])) {
        let getData = need[key][0] + "," + need[key][1];
        need[key] = getData;
      }
    }
    arr = need;
  }

  values.forEach(element => {
    if (that.$route.query[element]) {
      if (need != null && typeof (need) == "string" && need.toLowerCase() == "pagesize" && element.toLowerCase() ==
        "pagenumer") {
        arr["PageNumer"] = 1;
      } else {
        arr[element] = that.$route.query[element];
      }
    }
  });
  arr["path"] = encodeURI(path);
  that.$router.replace({
    path: '/redirect',
    query: arr
  });
  // that.$router.push({
  //   path: path,
  //   query: arr
  // }); // 路由跳转变值
};


window.paging = function (that, callback, ...value) { // 根据路由取值
  let arr = []

  if (JSON.stringify(that.$route.query) == '{}') {
    var PageNumer = null
    var PageSize = null
    arr.PageNumer = PageNumer;
    arr.PageSize = PageSize;
    callback(arr);
  } else {
    if (that.$route.query.PageNumer == undefined) { //  判断 防止页码和页数没有值
      var PageNumer = 1;
      if (that.paging.PageNumer != undefined) {
        that.paging.PageNumer = PageNumer
      }
    } else {

      var PageNumer = that.$route.query.PageNumer;
      if (that.paging.PageNumer != undefined) {
        that.paging.PageNumer = PageNumer;
      }

    }
    if (that.$route.query.PageSize == undefined) {

      var PageSize = 10
      if (that.paging.PageSize != undefined) {
        that.paging.PageSize = 10
      }

    } else {

      var PageSize = that.$route.query.PageSize
      if (that.paging.PageSize != undefined) {
        that.paging.PageSize = PageSize * 1
      }

    }

    arr.PageNumer = PageNumer;
    arr.PageSize = PageSize;

    value.forEach(element => {
      let router = that.$route.query[element];
      if (!router && router != 0) {
        router = null
      }
      arr[element] = router
    });
    callback(arr);

  }
}

// 返回
window.back = function (that) {
  var url = that.$route.query.url;
  if (url == null || typeof (url) == "undefined" || url == "") {
    window.history.go(-1);
  } else {
    that.$router.push(url);
  }

}

window.setInt = function (val) {
  var first = "";
  if (val == null || typeof (val) == "undefined") {
    val = "";
  }
  if (val != "") {
    first = val[0];
  }
  val = val.toString();
  val = val.replace(/[^\d.]/g, "");
  val = val.replace(/\.{1,}/g, "");
  val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  val = val.replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, '$1$2.$3'); //最多输入5个小数

  if (val.indexOf(".") < 0 && val != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    val = parseInt(val);
  }
  if (first == "-") {
    val = 0 - val;
  }
  return val;
}
window.setTwoFloat = function (val) {
  var first = "";
  if (val == null || typeof (val) == "undefined") {
    val = "";
  }
  if (val != "") {
    first = val[0];
  }

  val = val.toString();
  val = val.replace(/[^\d.]/g, "");
  val = val.replace(/\.{2,}/g, ".");
  val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  val = val.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //最多输入5个小数
  if (val.indexOf(".") < 0 && val != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    val = parseFloat(val);
  }

  if (first == "-") {
    val = 0 - val;
  }

  return val;
}

//设置两位小数，自动补齐 默认保留2位小数点
window.setTwoDecimal = function (val, _iFixed) { // val:需要转换的值 ,_iFixed需要保留的小数点位数(默认2位)

  if (val == null || isNaN(val) || val == '') {
    return '';
  }
  if (parseFloat(val + "") == 0) {
    return val;
  }
  _iFixed = setInt(_iFixed);
  if (_iFixed == null || isNaN(_iFixed) || _iFixed == '') {
    _iFixed = 2;
  }
  return parseFloat(val).toFixed(_iFixed);
  //return moneySwitch(parseFloat(val),2);
};


window.moneySwitch = function (money, precision) { //precision是需要精确的位数，如百分位就是2
  var result = 0;
  //先进行一个千分位的四舍五入，保证3.0999这种情况在保留一位小数的时候能是对的，这一位可以这么做没什么问题
  var money = parseFloat(money).toFixed(3);
  try {
    var int_part = money.split(".")[0], //小数点前的整数
      point_num = money.split(".")[1], //取小数点后面的小数
      precision_num = point_num[3 - precision];
    if (precision_num > 4) { //五入的情况
      if (precision == 1) {
        point_num = parseInt(point_num) + 10 + "";
        if (point_num.length > 3) { //说明往整数位进1
          int_part = parseInt(int_part) + 1 + "";
          point_num = point_num[1] + point_num[2];
        } else {
          point_num = point_num[0] + point_num[1];
        }
        result = parseFloat(int_part + "." + point_num);
      } else if (precision == 2) {
        point_num = parseInt(point_num) + 100 + "";
        if (point_num.length > 3) { //说明往整数位进1
          int_part = parseInt(int_part) + 1 + "";
          point_num = point_num[1];
        } else {
          point_num = point_num[0];
        }
        result = parseFloat(int_part + "." + point_num);
      } else if (precision == 3) {
        int_part = parseInt(int_part) + 1 + "";
        point_num = 0;
      }
      result = parseFloat(int_part + "." + point_num);
    } else { //四舍的情况
      if (precision == 1) {
        point_num = point_num[0] + point_num[1];
      } else if (precision == 2) {
        point_num = point_num[0];
      } else if (precision == 3) {
        point_num = 0;
      }
      result = parseFloat(int_part + "." + point_num);
    }
  } catch (e) {
    return parseFloat(money).toFixed(2); //如果过程中有出错就tofixed代替为解决
  }
  return result.toFixed(2);
};


//去除数组内的重复
window.onArrUnique = function (arr) {
  const res = new Map();
  return arr.filter((arr) => !res.has(arr.value) && res.set(arr.value, 1));
}
// 专业数据处理
window.onCascaderData = function (_this, obj) {
  let iCount = 0;
  //获取院部数据,去除重复性
  let arrCollege = onCascaderCollege(_this, obj);
  arrCollege.filter(item => {
    _this.$set(
      _this.optMajor, iCount, {
      value: item.value,
      label: item.label,
      //获取专业数据
      children: onCascaderChildren(_this, obj, item.value),
    }
    );
    _this.optMajor.splice();
    iCount++;
  });
}
// 生成院部临时数组
window.onCascaderCollege = function (_this, obj) {
  let iCount = 0;
  let arr = [];
  obj.filter(item => {
    _this.$set(
      arr, iCount, {
      value: item.collegeId,
      label: item.college,
    },
    );
    arr.splice();
    iCount++;
  });
  return onArrUnique(arr);
}
// 制作专业临时数组
window.onCascaderChildren = function (_this, obj, _type) {
  let iCount = 0;
  let arr = [];
  obj.filter(item => {
    if (item.collegeId === _type) {
      _this.$set(
        arr, iCount, {
        value: item.majorId,
        label: item.name,
      }
      );
      arr.splice();
      iCount++;
    }
  });
  return arr;
}



/*
        objDate:时间
        sign:日期分隔符,默认'-'
        dateType:输出格式,默认'YYYY-MM-DD'
      */
window.dateFormat = function (objDate, sign, dateType) {
  //如果没有传递符号，给一个默认的符号
  if (!sign) {
    sign = '-';
  }
  if (!dateType) {
    dateType = 'YYYY-MM-DD';
  }
  objDate = new Date(objDate);
  //获取d里面年月日时分秒
  let year = objDate.getFullYear(),
    month = objDate.getMonth() + 1,
    sun = objDate.getDate(),
    hours = objDate.getHours(),
    minutes = objDate.getMinutes(),
    seconds = objDate.getSeconds();

  switch (dateType.toUpperCase()) {
    case 'YYYY': //年
      return year;
    case 'YYYY-MM': //年月
      return year + sign + mendTimeZero(month);
    case 'YYYY-MM-DD': //年月日
      return year + sign + mendTimeZero(month) + sign + mendTimeZero(sun);
    case 'YYYY-MM-DD HH':
      return year + sign + mendTimeZero(month) + sign + mendTimeZero(sun) + ' ' + mendTimeZero(hours);
    case 'YYYY-MM-DD HH:MM':
      return year + sign + mendTimeZero(month) + sign + mendTimeZero(sun) + ' ' + mendTimeZero(hours) +
        ':' + mendTimeZero(minutes);
    default:
      return year + sign + mendTimeZero(month) + sign + mendTimeZero(sun) + ' ' + mendTimeZero(hours) + ':' +
        mendTimeZero(minutes) + ':' + mendTimeZero(seconds);
  }
}

/**
 * 拼充时间
 * @param {String} dateString 日期字符串
 * @param {Boolean} type true 00:00:00  false 23:59:59
 */
window.getHourOfDay = function (dateString, type) {
  // 创建 Date 对象
  const date = new Date(dateString);

  // 检查日期是否有效
  if (isNaN(date.getTime())) {
    throw new Error("Invalid date string");
  }

  // 获取年、月、日
  const year = date.getFullYear();
  const month = date.getMonth(); // getMonth() 返回 0-11 之间的值
  const day = date.getDate();

  // 创建当天的最后一小时的 Date 对象
  const lastHourDate = type ? new Date(year, month, day, 0, 0, 0) : new Date(year, month, day, 23, 59, 59);

  // 格式化为 YYYY-MM-DD HH:mm:ss 格式的字符串
  const formattedDate = lastHourDate
    .toISOString()
    .replace("T", " ")
    .substring(0, 19);

  return lastHourDate;
}




// 10内数字前面加0
window.mendTimeZero = function (num) {
  return (num = num < 10 ? '0' + num : num)
}
// 确认绑定值是否有值
window.fieldNoValue = function (obj) {
  if (obj == null || typeof (obj) == "undefined" || obj == '') {
    return '暂无数据';
  }
  return obj;
};
/// 判断性别 true:男 | false 女
window.isGender = function (_value) {
  if (_value != null && _value != '' && _value.indexOf('男') >= 0) {
    return true;
  } else {
    return false;
  }
};

// 验证手机号码 true:错 false:对
window.regMobilePhone = function (value) {
  var reg = /^1\d{10}$/;
  if (value != 0 && !reg.exec(value)) {
    return true;
  } else {
    return false;
  }
};
// 验证邮箱 true:错 false:对
window.regMail = function (value) {
  var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
  if (value != 0 && !reg.exec(value)) {
    return true;
  } else {
    return false;
  }
}
// 验证身份证
window.regIDCard = function (value) {
  var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
  if (value != 0 && !reg.exec(value)) {
    return true;
  } else {
    return false;
  }
};
// 正整数
window.regInt = function (value) {
  var reg = /^[1-9]\d*$/;
  if (value != 0 && !reg.exec(value)) {
    return true;
  } else {
    return false;
  }
}

/**
 * @description 常规分数格式
 * @param {Object} value
 */
window.regFraction = function (value) {
  var reg = /^(\-)?\d+(\.[0-9]{1,2})?$/;
  if (value != 0 && !reg.exec(value)) {
    return true;
  } else {
    return false;
  }
}


/**
 * 数据转换为树形（递归），示例：toTreeByRecursion(source, 'id', 'parentId', null, 'children')
 * @param {Array} source 数据
 * @param {String} idField 标识字段名称
 * @param {String} parentIdField 父标识字段名称
 * @param {Any} parentIdNoneValue 父级标识空值
 * @param {String} childrenField 子节点字段名称
 * @param {Object} treeOption tree树形配置
 */
window.toTreeByRecursion = function (
  source = [],
  idField = 'id',
  parentIdField = 'parentId',
  parentIdNoneValue = '',
  childrenField = 'children',
  treeOption = undefined
) {
  const treeOptions = {
    enable: false, // 是否开启转tree插件数据
    keyField: 'key', // 标识字段名称，默认为key
    valueField: 'value', // 值字段名称，默认为value
    titleField: 'title', // 标题字段名称，默认为title

    keyFieldBind: 'id', // 标识字段绑定字段名称，默认为id
    valueFieldBind: 'id', // 值字段名称绑定字段名称，默认为id
    titleFieldBind: 'name' // 标题字段名称绑定字段名称，默认为name
  }
  // 合并tree树形配置
  if (treeOption) {
    Object.assign(treeOptions, treeOption)
  }

  // 对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(source))
  return cloneData.filter(parent => {
    // 返回每一项的子级数组
    const branchArr = cloneData.filter(child => parent[idField] === child[parentIdField])

    // 绑定tree树形配置
    if (treeOptions.enable) {
      branchArr.map(child => {
        child[treeOptions.keyField] = child[treeOptions.keyFieldBind]
        child[treeOptions.valueField] = child[treeOptions.valueFieldBind]
        child[treeOptions.titleField] = child[treeOptions.titleFieldBind]
        return child
      })
    }

    // 如果存在子级，则给父级添加一个children属性，并赋值，否则赋值为空数组
    if (branchArr.length > 0) {
      parent[childrenField] = branchArr
    } else {
      parent[childrenField] = []
    }

    // 绑定tree树形配置
    if (treeOptions.enable) {
      parent[treeOptions.keyField] = parent[treeOptions.keyFieldBind]
      parent[treeOptions.valueField] = parent[treeOptions.valueFieldBind]
      parent[treeOptions.titleField] = parent[treeOptions.titleFieldBind]
    }

    return parent[parentIdField] === parentIdNoneValue; // 返回第一层
  })
}

window.checkTime = function (i) {
  var result = i + '';
  if (i < 10) {
    result = '0' + i;
  }
  return result;
}


let moment = require("moment");
window.timeTransform = function (time, format) {
  if (time === "") {
    return "";
  }
  if (format == null || format == "") {
    format = "YYYY-MM-DDTHH:mm:ss.SSS";
  }
  var result = moment(time).format(format);
  return result;
}

window.getTimeID = function () {
  let time = new Date();
  let format = "YYYYMMDDHHmmssSSS";
  var result = moment(time).format(format);
  return result;
}

/*
  例 moment('2010-10-20').isBefore('2010-10-21'); ==》 true
  start:2010-10-20 需要判断时间
  end:2010-10-21 当前时间
  true: 过时，false 未过时
*/
window.compareDate = function (start, end) {
  return moment(start).isBefore(end);
}


window.Join = function (data) {
  if (data != null) {
    if (Array.isArray(data)) {
      if (data.length > 0) {
        var val = "";
        for (var it of data) {
          if (val == "") {
            val = it;
          } else {
            val += "," + it;
          }
        }
        return val;
      }
    }
    return data;

  }
}




/**
 * 头像
 * @param {String} _photo 头像，
 * @param {String} _gender 性别，
 */
window.onGetAvatorUrl = function (_this, _photo, _gender) {
  let tempUrl = '';
  if (_photo == null || typeof (_photo) == "undefined" || _photo == '') {
    if (isGender(_gender)) {
      // 男
      tempUrl = require('@/assets/image/defaultAvatar_Male.jpg');
    } else {
      // 女
      tempUrl = require('@/assets/image/defaultAvatar_Female.jpg');
    }
  } else {
    tempUrl = _this.$ServerUrl() + _photo;
  }
  return tempUrl;
}

/**
 * @description 注销
 * @param {Object} that
 */
window.WebLogout = function (that) {
  that.$RemoveKey();
  setTimeout(function () {
    if (dd.env.platform !== "notInDingTalk") {
      that.$router.push({
        path: '/Logout',
        query: {
          url: that.$router.history.current.fullPath
        },
      });
    } else {
      that.$router.push({
        path: '/login',
      });
    }
    return false;
  }, 1500);
}


/**
 * 判断是否空值 true:是空值
 * @param {String} obj 需要判断的值
 */
window.regNull = function (obj) {
  if (obj != null && typeof (obj) != "undefined" && obj != '') {
    return false;
  } else {
    return true;
  }
}
/**
 * @description 判断数组是否为空值，true：空值
 * @param {Object} obj
 */
window.regNullArray = function (obj) {
  if (obj != null && obj.length != 0) {
    return false;
  } else {
    return true;
  }
}

window.delHtml = function (obj) {
  if (regNull(obj)) {
    return obj;
  } else {
    return obj.replace(/<[^>]+>/g, "").replace(/&nbsp;/ig, "");
  }
}

/**
 * @description 计算列表k 操作列宽
 * @param {Object} that
 * @param {Object} arrData
 */
window.onGetWidth = function (that, arrData) {
  let tpNumber = 0;
  arrData.forEach(function (item) {
    if (item) {
      tpNumber = tpNumber + 80;
    }
  });
  if (tpNumber < 100) {
    return 100;
  } else {
    return tpNumber;
  }
}



/**
 * @description 线型数据转换树型数据
 * @param {Object} a 数据
 * @param {Object} idStr id名
 * @param {Object} pidStr pid名
 * @param {Object} chindrenStr chindren名
 */
window.onGetJsonToTree = function (a, idStr, pidStr, chindrenStr) {
  var r = [],
    hash = {},
    id = idStr,
    pid = pidStr,
    children = chindrenStr,
    i = 0,
    j = 0,
    len = a.length;
  for (; i < len; i++) {
    hash[a[i][id]] = a[i];
  }
  for (; j < len; j++) {
    var aVal = a[j],
      hashVP = hash[aVal[pid]];
    if (hashVP) {
      !hashVP[children] && (hashVP[children] = []);
      hashVP[children].push(aVal);
    } else {
      r.push(aVal);
    }
  }
  return r;
}

/**
 * @description 将树型数据转换为线型数组
 * @param {Object} arr
 */
window.onGetTreeConvertList = function (arr) {
  let res = []
  arr.forEach((item) => {
    res.push(item)
    if (item.children) {
      res.push(...onGetTreeConvertList(item.children))
    }
    //delete item.children;
  })
  return res;
}


/**
 * @description 简易生成随机GUID
 */
window.onGetRandomGUID = function () {
  // 预定义16进制字符表
  const hexChars = '0123456789abcdef';
  // 生成16个随机字节（128位）
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);

  // 按照 UUID v4 规范设置特定位
  bytes[6] = (bytes[6] & 0x0f) | 0x40; // 第13位必须是4
  bytes[8] = (bytes[8] & 0x3f) | 0x80; // 第17位必须是8/9/a/b

  // 拼接成标准格式：8-4-4-4-12
  return [
    bytes.slice(0, 4),
    bytes.slice(4, 6),
    bytes.slice(6, 8),
    bytes.slice(8, 10),
    bytes.slice(10, 16)
  ]
  .map(arr => Array.from(arr, b => hexChars[b >> 4] + hexChars[b & 0x0f]).join(''))
  .join('-');
}







/**
 * @description 计算活动状态名称 和 按钮显示
 * @param {Object} _isSignUp 是否需要报名
 * @param {Object} _isStatus 活动当前状态
 * @param {Object} _isImportScope 是否导入报名范围
 * @param {Object} _isUpload 是否上传
 * @param {Object} _valSignupStart 报名开始时间
 * @param {Object} _valSignupEnd 报名结束时间
 * @param {Object} _valStarTime 活动开始时间
 * @param {Object} _valEndTime 活动结束时间
 * @param {object} _valUploadTime 学生上传文件截止时间
 * @param {Object} _isAdmin 是否为审核员
 * @param {object} _isMyClass 是否可以代报名
 * ////////////////////////////////////////////学生
 * @param {object} _isStudent 是否为学生
 * @param {object} _isJoin 是否可以报名(当报名成功后，变成为false)
 * @param {object} _valRosterStatus 名单状态 0:未报名  1：待审核 2：审核不通过 3：审核通过
 * @param {object} _isSignIn 是否需要签到
 * @param {object} _isStudentSignUp 学生签到情况
 * @param {object} _isAudit 是否需要报名审核
 *
 */
window.onGetActivityStatus = function (_isSignUp, _isStatus, _isImportScope, _isUpload, _valSignupStart, _valSignupEnd,
  _valStarTime, _valEndTime, _valUploadTime, _isAdmin, _isMyClass, _isStudent, _isJoin, _valRosterStatus, _isSignIn,
  _isStudentSignUp, _isAudit,) {

  // 活动各状态数组
  let arrStatus = ['报名未开始', '开始报名', '报名结束', '已确认名单', '待确认名单', '进行中', '未计入综合分', '活动已结束', '待学生上传文件', '上传活动相关图片',
    '活动未开始'
  ];
  let arrStudentStatus = ['无需报名', '未报名', '待审核', '审核不通过', '已报名', '未参加', '已参加', '等待报名', '已签到', '未签到', '统计中', '非报名范围内'];
  let arrReturn = {
    isBtnEdit: false, // 编辑
    isBtnDelete: false, // 删除
    isBtnImportScope: false, // 导入报名范围
    isBtnConfirm: false, // 确认名单
    isBtnRevoke: false, // 撤消
    isBtnAwards: false, // 评奖
    isBtnFinally: false, // 最后计入综合分
    isBtnReplace: false, // 是否可以代报名
    isBtnShow: true, // 是否显示操作
    statusName: '待报名', // 状态名称

    isBtnCancel: false, // 是否取消报名
    isBtnJoin: false, // 是否显示立即报名
    isBtnUpload: false, // 是否上传文件
    isBtnSignIn: false, // 是否显示签到按钮
    statusStuName: '', // 学生报名情况
  }
  arrReturn.isBtnShow = _isAdmin;

  let icount = 0;

  // 判断活动是否已撤消
  if (_isStatus == -1) {
    arrReturn.statusName = '已撤销'; //报名未开始
    arrReturn.statusStuName = '已撤销'; //报名未开始
  } else {
    // 判断是否报名，需要报名为有流程报名
    if (_isSignUp) {
      /*有流程活动*/

      // 报名时间未开始
      if (!compareDate(timeTransform(_valSignupStart), timeTransform(new Date()))) {

        arrReturn.statusName = arrStatus[0]; //报名未开始
        arrReturn.statusStuName = _isJoin ? arrStudentStatus[7] : arrStudentStatus[11]; //报名未开始
        arrReturn.isBtnEdit = true;
        arrReturn.isBtnDelete = true;
        arrReturn.isBtnReplace = false;
        arrReturn.isBtnImportScope = _isImportScope;





      } else if (compareDate(timeTransform(_valSignupStart), timeTransform(new Date())) && !compareDate(timeTransform(
        _valSignupEnd), timeTransform(new Date()))) {
        // 报名时间开始 报名时间未结束


        arrReturn.statusName = arrStatus[1]; //报名开始
        arrReturn.isBtnRevoke = true;
        arrReturn.isBtnConfirm = _isAudit; // 判断是否需要审核
        arrReturn.isBtnReplace = _isMyClass;

        // 判断是否为学生角色
        if (_isStudent) {
          // 判断是否 可以报名


          // 根据审核状态显示
          switch (_valRosterStatus) {
            case 0:
              arrReturn.statusStuName = _isJoin ? arrStudentStatus[1] : arrStudentStatus[11]; //未报名
              arrReturn.isBtnJoin = _isJoin;
              break;
            case 1:
              arrReturn.statusStuName = arrStudentStatus[2]; //待审核
              arrReturn.isBtnCancel = true;
              break;
            case 2:
              arrReturn.statusStuName = arrStudentStatus[3]; //审核不通过
              break;
            case 3:
              arrReturn.statusStuName = arrStudentStatus[4]; //已报名
              arrReturn.isBtnCancel = true;
              break;
          }

        }



      } else if (compareDate(timeTransform(_valSignupEnd), timeTransform(new Date())) && !compareDate(timeTransform(
        _valStarTime), timeTransform(new Date()))) {
        // 报名时间结束，活动时间未开始

        if (_isStatus == 1) { // 1=>待报名 等于 未确认名单
          arrReturn.statusName = arrStatus[2]; //报名结束
          arrReturn.statusStuName = _isAudit ? arrStudentStatus[2] : arrStudentStatus[4];

        } else {
          // 学生看到的活动状态有所不同
          arrReturn.statusName = _isStudent ? arrStatus[2] : arrStatus[3]; //名单已确认

          if (_isStudent) {


            // _isAudit 判断是否需要审核
            switch (_valRosterStatus) {
              case 0:
                arrReturn.statusStuName = _isJoin ? arrStudentStatus[1] : arrStudentStatus[
                  11]; // 如果状态为0 进行判断是否可以报名，可以报名为 未报名
                break;
              case 1:
                arrReturn.statusStuName = arrStudentStatus[2]; //待审核
                break;
              case 2:
                arrReturn.statusStuName = arrStudentStatus[3]; //审核不通过
                break;
              case 3:
                arrReturn.statusStuName = arrStudentStatus[4]; //审核通过
                break;
            }

          }
        }
        arrReturn.isBtnConfirm = _isAudit;
        arrReturn.isBtnRevoke = true;


      } else if (compareDate(timeTransform(_valStarTime), timeTransform(new Date())) && !compareDate(timeTransform(
        _valEndTime), timeTransform(new Date()))) {
        // 活动时间开始
        if (_isStatus == 1) {
          arrReturn.statusName = _isStudent ? arrStatus[2] : arrStatus[4]; //待确认名单
          arrReturn.isBtnConfirm = _isAudit;
          arrReturn.isBtnRevoke = true;
          arrReturn.statusStuName = _isAudit ? arrStudentStatus[2] : arrStudentStatus[4];
        } else {
          arrReturn.statusName = arrStatus[5]; //进行中


          // 判断是否为学生角色
          if (_isStudent) {

            // 根据学生报名状态进行判断
            switch (_valRosterStatus) {
              case 0: // 为未报名
                arrReturn.statusStuName = _isJoin ? arrStudentStatus[1] : arrStudentStatus[
                  11]; // 如果状态为0 进行判断是否可以报名，可以报名为 未报名
                break;
              case 3:
                // 判断是否要活动签到
                if (_isSignIn) {
                  arrReturn.isBtnSignIn = _isStudentSignUp ? false : true; // 签到按钮
                  arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[8] : arrStudentStatus[9];
                } else {
                  arrReturn.statusStuName = arrStudentStatus[4]
                }
                break;
              default: // 其他状态都为 审核不通过
                arrReturn.statusStuName = arrStudentStatus[3]; //审核不通过
                break;
            }
          }
        }
      } else if (compareDate(timeTransform(_valEndTime), timeTransform(new Date())) && !_isUpload) {
        // 活动时间结束，无学生上传文件
        if (_isStatus == 1) {
          arrReturn.statusName = _isStudent ? arrStatus[2] : arrStatus[4]; //待确认名单
          arrReturn.isBtnConfirm = _isAudit;
          arrReturn.isBtnRevoke = true;
          arrReturn.statusStuName = _isAudit ? arrStudentStatus[2] : arrStudentStatus[4];
        } else if (_isStatus == 2) {
          arrReturn.statusName = _isStudent ? arrStatus[7] : arrStatus[6]; //未计入综合分
          arrReturn.isBtnAwards = true;
          arrReturn.isBtnFinally = true;
        } else {
          arrReturn.statusName = arrStatus[7]; //活动已结束
          arrReturn.isBtnAwards = true;
          arrReturn.isBtnFinally = true;
        }


        // 判断是否为学生角色
        if (_isStudent && _isStatus > 1) {
          // 根据学生报名状态进行判断
          switch (_valRosterStatus) {
            case 0: // 为未报名
              arrReturn.statusStuName = _isJoin ? arrStudentStatus[1] : arrStudentStatus[
                11]; // 如果状态为0 进行判断是否可以报名，可以报名为 未报名
              break;
            case 3:
              // 判断是否要活动签到
              if (_isSignIn) {
                arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[8] : arrStudentStatus[9];
              } else {
                arrReturn.statusStuName = arrStudentStatus[6]; //已参加
              }
              break;
            default: // 其他状态都为 审核不通过
              arrReturn.statusStuName = arrStudentStatus[3]; //审核不通过
              break;
          }
        }


      } else if (compareDate(timeTransform(_valEndTime), timeTransform(new Date())) && _isUpload && !compareDate(
        timeTransform(_valUploadTime), timeTransform(new Date()))) {
        // 活动时间结束，学生上传文件截止时间未结束时
        if (_isStatus == 1) {
          arrReturn.statusName = _isStudent ? arrStatus[2] : arrStatus[4]; //待确认名单
          arrReturn.isBtnConfirm = _isAudit;
          arrReturn.isBtnRevoke = true;
          arrReturn.statusStuName = _isAudit ? arrStudentStatus[2] : arrStudentStatus[4];
        } else {
          arrReturn.statusName = _isStudent ? arrStatus[9] : arrStatus[8]; //待学生上传文件
          arrReturn.isBtnAwards = true;


          // 判断是否为学生角色
          if (_isStudent && _isStatus > 1) {
            // 根据学生报名状态进行判断
            switch (_valRosterStatus) {
              case 0: // 为未报名
                arrReturn.statusStuName = _isJoin ? arrStudentStatus[1] : arrStudentStatus[
                  11]; // 如果状态为0 进行判断是否可以报名，可以报名为 未报名
                break;
              case 3:
                // 判断是否要活动签到
                if (_isSignIn) {
                  arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[8] : arrStudentStatus[9];
                  arrReturn.isBtnUpload = _isStudentSignUp; // 签到过的学生才能上传文件
                } else {
                  arrReturn.statusStuName = arrStudentStatus[6]; //已参加
                  arrReturn.isBtnUpload = true; // 签到过的学生才能上传文件
                }
                break;
              default: // 其他状态都为 审核不通过
                arrReturn.statusStuName = arrStudentStatus[3]; //审核不通过
                break;
            }
          }


        }
      } else if (compareDate(timeTransform(_valEndTime), timeTransform(new Date())) && _isUpload && compareDate(
        timeTransform(_valUploadTime), timeTransform(new Date()))) {
        // 活动时间结束，学生上传文件截止时间已结束
        if (_isStatus == 1) {
          arrReturn.statusName = _isStudent ? arrStatus[2] : arrStatus[4]; //待确认名单
          arrReturn.isBtnConfirm = _isAudit;
          arrReturn.isBtnRevoke = true;
          arrReturn.statusStuName = _isAudit ? arrStudentStatus[2] : arrStudentStatus[4];
        } else if (_isStatus == 2) {
          arrReturn.statusName = _isStudent ? arrStatus[7] : arrStatus[6]; //未计入综合分
          arrReturn.isBtnAwards = true;
          arrReturn.isBtnFinally = true;
        } else {
          arrReturn.statusName = arrStatus[7]; //活动已结束
          arrReturn.isBtnAwards = true;
          arrReturn.isBtnFinally = true;
        }


        // 判断是否为学生角色
        if (_isStudent && _isStatus > 1) {
          // 根据学生报名状态进行判断
          switch (_valRosterStatus) {
            case 0: // 为未报名
              arrReturn.statusStuName = _isJoin ? arrStudentStatus[1] : arrStudentStatus[
                11]; // 如果状态为0 进行判断是否可以报名，可以报名为 未报名
              break;
            case 3:
              // 判断是否要活动签到
              if (_isSignIn) {
                arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[6] : arrStudentStatus[5];
              } else {
                arrReturn.statusStuName = arrStudentStatus[6]; //已参加
              }
              break;
            default: // 其他状态都为 审核不通过
              arrReturn.statusStuName = arrStudentStatus[3]; //审核不通过
              break;
          }
        }
      }



    } else {
      /*不需要报名活动*/
      arrReturn.isBtnDelete = true;
      if (!compareDate(timeTransform(_valStarTime), timeTransform(new Date())) && !compareDate(timeTransform(
        _valEndTime), timeTransform(new Date()))) {
        // 活动时间 未开始，
        arrReturn.statusName = arrStatus[10]; //活动未开始
        arrReturn.statusStuName = arrStudentStatus[0]; //无需报名
        arrReturn.isBtnEdit = true;
      } else if (compareDate(timeTransform(_valStarTime), timeTransform(new Date())) && !compareDate(timeTransform(
        _valEndTime), timeTransform(new Date()))) {
        // 活动时间 开始
        arrReturn.statusName = arrStatus[5]; //进行中

        // 判断是否为学生角色
        if (_isStudent) {

          // 判断是否要活动签到
          if (_isSignIn) {
            arrReturn.isBtnSignIn = _isStudentSignUp ? false : true; // 签到按钮
            arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[8] : arrStudentStatus[9];
          } else {
            arrReturn.statusStuName = arrStudentStatus[0]; //统计中
          }

        }
      } else if (compareDate(timeTransform(_valEndTime), timeTransform(new Date())) && !_isUpload) {
        // 活动时间结束，无学生上传文件
        arrReturn.isBtnAwards = true;
        arrReturn.isBtnFinally = true;

        if (_isStatus == 1) {
          arrReturn.statusName = _isStudent ? arrStatus[7] : arrStatus[6]; //未计入综合分
        } else {
          arrReturn.statusName = arrStatus[7]; //活动已结束
          arrReturn.isBtnDelete = false;
        }

        // 判断是否为学生角色
        if (_isStudent) {

          // 判断是否要活动签到
          if (_isSignIn) {
            // 判断学生是否签到，签到为已参加
            arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[6] : arrStudentStatus[5];
          } else {
            //通过活动状态显示 学生活动状态
            if (_isStatus == 1) {
              arrReturn.statusStuName = arrStudentStatus[0]; //统计中
            } else {
              // 判断学生是否参加了活动了
              arrReturn.statusStuName = _valRosterStatus == 3 ? arrStudentStatus[6] : arrStudentStatus[5];
            }
          }
        }
      } else if (compareDate(timeTransform(_valEndTime), timeTransform(new Date())) && _isUpload && !compareDate(
        timeTransform(_valUploadTime), timeTransform(new Date()))) {
        // 活动时间结束，学生上传文件截止时间未结束时
        arrReturn.isBtnAwards = true;
        arrReturn.statusName = _isStudent ? arrStatus[9] : arrStatus[8]; //待学生上传文件

        // 判断是否为学生角色
        if (_isStudent) {
          // 判断是否要活动签到
          if (_isSignIn) {
            // 判断学生是否签到，签到为已参加
            arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[6] : arrStudentStatus[5];
          } else {
            arrReturn.statusStuName = arrStudentStatus[0]; //统计中
          }
        }
      } else if (compareDate(timeTransform(_valEndTime), timeTransform(new Date())) && _isUpload && compareDate(
        timeTransform(_valUploadTime), timeTransform(new Date()))) {
        // 活动时间结束，学生上传文件截止时间已结束
        arrReturn.isBtnAwards = true;
        arrReturn.isBtnFinally = true;
        if (_isStatus == 1) {
          arrReturn.statusName = _isStudent ? arrStatus[7] : arrStatus[6]; //未计入综合分
        } else {
          arrReturn.statusName = arrStatus[7]; //活动已结束
          arrReturn.isBtnDelete = false;
        }
        // 判断是否为学生角色
        if (_isStudent) {
          // 判断是否要活动签到
          if (_isSignIn) {
            // 判断学生是否签到，签到为已参加
            arrReturn.statusStuName = _isStudentSignUp ? arrStudentStatus[6] : arrStudentStatus[5];
          } else {
            //通过活动状态显示 学生活动状态
            if (_isStatus == 1) {
              arrReturn.statusStuName = arrStudentStatus[0]; //统计中
            } else {
              // 判断学生是否参加了活动了
              arrReturn.statusStuName = _valRosterStatus == 3 ? arrStudentStatus[6] : arrStudentStatus[5];
            }
          }
        }
      }
    }
  }
  return arrReturn;
}
